module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-group",
    on: {
      "active": _vm.setActive
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dec957fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordions/accordions.vue
// module id = 720
// module chunks = 85